import {RootState} from "@core/store";
import {closeMessage} from "@core/store/slices/snackbarSlice";
import {Alert, Snackbar as MuiSnackbar, Slide, SlideProps} from "@mui/material";
import {translate} from "@util";
import {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";

type TransitionProps = Omit<SlideProps, "direction">;

const Snackbar = () => {
  const dispatch = useDispatch();
  const message = useSelector((state: RootState) => state.snackbar.message);

  useEffect(() => {
    setOpenSnackbar(message !== null);
  }, [message]);

  const [openSnackbar, setOpenSnackbar] = useState<boolean>(false);

  const handleCloseSnackbar = (
    event: React.SyntheticEvent | Event,
    reason: string,
  ) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSnackbar(false);
    setTimeout(() => {
      dispatch(closeMessage());
    }, 300);
  };

  function TransitionUp(props: TransitionProps) {
    return <Slide {...props} direction="up" />;
  }

  return (
    <MuiSnackbar
      open={openSnackbar}
      autoHideDuration={3000}
      TransitionComponent={TransitionUp}
      onClose={handleCloseSnackbar}
      sx={{zIndex: openSnackbar ? 1400 : -1}}>
      <Alert
        sx={{width: {xs: "100%"}}}
        severity={message?.severity ?? "info"}
        variant="filled">
        {translate(message?.text ?? "")}
      </Alert>
    </MuiSnackbar>
  );
};

export {Snackbar};
